import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

const SalesGPReport = () => import ('@/views/reports/salesGPReport.vue');

const AgeingReports = () => import ('@/views/reports/ageingReports.vue');

/*Angelia Start*/
const PurchasePRT = () => import ('@/views/purchasePRT/details.vue');
const PurchasePRTs = () => import ('@/views/purchasePRT/master.vue');
/*Angelia END*/

// SETUP COMPONENTS TO CONSTANTS
// const Calendar = () =>
//     import ( /* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// const Charts = () =>
//     import ( /* webpackChunkName: "dashboard" */ '@/views/Charts.vue');
// const Buttons = () =>
//     import ( /* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
// const Cards = () =>
//     import ( /* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
// const GridSystem = () =>
//     import ( /* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');

// const Icons = () =>
//     import ( /* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
// const Typography = () =>
//     import ( /* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import ( /* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import ( /* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
// const Widgets = () =>
//     import ( /* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Forms pages
// const FormElements = () =>
//     import ('@/views/Forms/FormElements.vue');
// const FormComponents = () =>
//     import ('@/views/Forms/FormComponents.vue');
// const FormValidation = () =>
//     import ('@/views/Forms/FormValidation.vue');
// const Pricing = () =>
//     import ( /* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
// const TimeLine = () =>
//     import ( /* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import ( /* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import ( /* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
// const Register = () =>
//     import ( /* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
// const Lock = () =>
//     import ( /* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');

// TableList pages
// const RegularTables = () =>
//     import ( /* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
// const SortableTables = () =>
//     import ( /* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
// const PaginatedTables = () =>
//     import ( /* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');

// Sales Functions pages
const Customers = () => import ('@/views/customers/master.vue');
const Customer = () => import ('@/views/customers/details.vue');

const Vendors = () => import ('@/views/vendors/master.vue');
const Vendor = () => import ('@/views/vendors/details.vue');

const PO = () => import ('@/views/purchases/order.vue');
const POS = () => import ('@/views/purchases/orders.vue');

const PI = () => import ('@/views/purchases/invoice.vue');
const PIS = () => import ('@/views/purchases/invoices.vue');

const CustomizedPrices = () => import ('@/views/customers/customizedPrices.vue');

const Sales = () => import ('@/views/sales/master.vue');
const Quotation = () => import ('@/views/sales/quotation.vue');
const Quotations = () => import ('@/views/sales/quotations.vue');
const Order = () => import ('@/views/sales/order.vue');
const Orders = () => import ('@/views/sales/orders.vue');
const Invoice = () => import ('@/views/sales/invoice.vue');
const Invoices = () => import ('@/views/sales/invoices.vue');

// Products Functions pages
const Products = () => import ('@/views/products/master.vue');
const Product = () => import ('@/views/products/details.vue');

// Sale Channel Pages
const SaleChannels = () => import ('@/views/saleChannels/master.vue');
const SaleChannel = () => import ('@/views/saleChannels/details.vue');

const ApprovalRequests = () => import ('@/views/Notifications/approvalRequests.vue');

const Locations = () => import ('@/views/inventory/locations.vue');

const Location = () => import ('@/views/inventory/location.vue');

// const stockcards  = () =>
//     import ('@/views/inventory/stockcards.vue');

// const stockcard = () =>
//     import ('@/views/inventory/stockcard.vue');

const CustomersSOA = () => import ('@/views/finance/customersSOA.vue');

const StockAdjustments  = () => import ('@/views/inventory/stockAdjustments.vue');

const StockAdjustment = () => import ('@/views/inventory/stockAdjustment.vue');

const StockAdjustmentDetails = () => import ('@/views/inventory/stockAdjustmentDetails.vue');

const stockin = () => import ('@/views/inventory/stockin.vue');

const stockout = () => import ('@/views/inventory/stockout.vue');

const stocktransfer = () => import ('@/views/inventory/stocktransfer.vue');

const stocktransfers = () => import ('@/views/inventory/stocktransfers.vue');

const stockcardDetails = () => import ('@/views/inventory/stockcardDetails.vue');

const productInventory = () => import ('@/views/inventory/productInventory.vue');

const invoiceFromDos = () => import ('@/views/sales/invoiceFromDos.vue');

const invoiceFromGRN = () => import ('@/views/purchases/invoiceFromGRNs.vue');

const GRNS = () => import ('@/views/purchases/grns.vue');

const GRN = () => import ('@/views/purchases/grn.vue');

const DebitNotes = () => import ('@/views/purchases/debitNotes.vue');

const DebitNote = () => import ('@/views/purchases/debitNote.vue');    

const TradeItemsPurchase = () => import ('@/views/purchases/tradeItemsPurchase.vue');

const DOS = () => import ('@/views/inventory/dos.vue');

const DO = () => import ('@/views/inventory/do.vue');

const Users = () => import ('@/views/users/master.vue');

const User = () => import ('@/views/users/details.vue');

const COAS = () => import ('@/views/finance/coa/master.vue');

const COA = () => import ('@/views/finance/coa/details.vue');

const Vouchers = () => import ('@/views/finance/vouchers/master.vue');

const Voucher = () => import ('@/views/finance/vouchers/details.vue');

const GLVouchers = () => import ('@/views/finance/glVouchers/master.vue');

const GLVoucher = () => import ('@/views/finance/glVouchers/details.vue');

const ContactCategories = () => import ('@/views/settings/contactCategories.vue');

const contactCategory = () => import ('@/views/settings/contactCategory.vue');

const Systems = () => import ('@/views/settings/systems.vue');

const System = () => import ('@/views/settings/system.vue');

const DocumentScanning = () => import ('@/views/purchases/documentScanning.vue');

const Assets = () => import ('@/views/assets/master.vue');

const Asset = () => import ('@/views/assets/details.vue');

const AssetClassifications = () => import ('@/views/assetClassifications/master.vue');

const AssetClassification = () => import ('@/views/assetClassifications/details.vue');

const AssetProtocols = () => import ('@/views/assetProtocols/master.vue');

const AssetProtocol = () => import ('@/views/assetProtocols/details.vue');

const RFIDS = () => import ('@/views/rfids/master.vue');

const RFID = () => import ('@/views/rfids/details.vue');

const rfidUpload = () => import ('@/views/rfids/uploadFile.vue');

const SalesReports = () => import ('@/views/reports/salesReports.vue');
const PurchaseReports = () => import ('@/views/reports/purchaseReports.vue');
const InventoryReports = () => import ('@/views/reports/inventoryReports.vue');
const FinanceReports = () => import ('@/views/reports/financeReports.vue');


const ReportSalesPriceHistory = () => import ('@/views/reports/salesPriceHistory.vue');

const ReportPurchasePriceHistory = () => import ('@/views/reports/purchasePriceHistory.vue');

const ReportInventoryStockBalance = () => import ('@/views/reports/inventoryStockBalance.vue');

const ReportSOA = () =>  import ('@/views/reports/soa.vue');

const ReportDebtors = () => import('@/views/reports/debtors.vue');

const ProductCategories = () => import ('@/views/settings/productCategories.vue');

const ProductCategory = () => import ('@/views/settings/productCategory.vue');
const PayrollSetup = () => import ('@/views/settings/payroll.vue');


/* Zehua Start */
const Receipt = () => import ('@/views/finance/receipts/salesreceipt.vue');
const Receipts = () => import ('@/views/finance/receipts/salesreceipts.vue');
const PurchaseReceipt = () => import ('@/views/finance/receipts/purchasereceipt.vue');
const PurchaseReceipts = () => import ('@/views/finance/receipts/purchasereceipts.vue');

// const creditNotes = () =>
//     import ('@/views/finance/creditNotes.vue');

const creditNote = () => import ('@/views/finance/creditNote.vue');

const SalesPIR = () => import ('@/views/salesPIR/details.vue');
const SalesPIRs = () => import ('@/views/salesPIR/master.vue');
const BankAccount = () => import ('@/views/SettingBankAccount/details.vue');
const BankAccounts = () => import ('@/views/SettingBankAccount/master.vue');
const InventoryMovements = () => import ('@/views/inventory/inventoryMovements.vue');

const SalesItemPickings = () => import ('@/views/sales/salesItemPicking.vue');

const OutstandingInvoices = () => import ('@/views/sales/outstandingInvoices.vue');
const CreditLimitExceeded = () => import ('@/views/sales/creditLimitExceeded.vue');
const OverdueInvoices = () => import ('@/views/sales/overdueInvoices.vue');
const ReceiptEntries = () => import ('@/views/sales/receiptEntries.vue');
const SalesApproval = () => import ('@/views/sales/salesApproval.vue');
const BulkPosting = () => import ('@/views/finance/bulkPosting.vue');
const JournalVouchers = () => import ('@/views/finance/journalVouchers/master.vue');
const JournalVoucher = () => import ('@/views/finance/journalVouchers/details.vue');
const BankReconciliation = () => import ('@/views/finance/bankReconciliation.vue');
const StockImpairments = () => import ('@/views/inventory/stockimpairment/master.vue');
const StockImpairment = () => import ('@/views/inventory/stockimpairment/detail.vue');    

const ARcreditNotes = () => import ('@/views/finance/ARCreditNote/master.vue');
const ARcreditNote = () => import ('@/views/finance/ARCreditNote/detail.vue');
const ARdebitNotes = () => import ('@/views/finance/ARDebitNote/master.vue');
const ARdebitNote = () => import ('@/views/finance/ARDebitNote/detail.vue');

const APcreditNotes = () => import ('@/views/finance/APCreditNote/master.vue');
const APcreditNote = () => import ('@/views/finance/APCreditNote/detail.vue');
const APdebitNotes = () => import ('@/views/finance/APDebitNote/master.vue');
const APdebitNote = () => import ('@/views/finance/APDebitNote/detail.vue');
const JVAccountLookup = () => import ('@/views/finance/jvAccountLookup.vue');

const UserChangePassword = () => import ('@/views/users/changePassword.vue');

const PeriodLocking = () => import ('@/views/finance/periodLocking.vue');

const BOMAssemblies = () => import ('@/views/inventory/bomassembly/master.vue');
const BOMAssembly = () => import ('@/views/inventory/bomassembly/detail.vue');
/* Zehua End */

// let componentsMenu = {
//     path: '/components',
//     component: DashboardLayout,
//     redirect: '/components/buttons',
//     name: 'Components',
//     children: [{
//             path: 'buttons',
//             name: 'Buttons',
//             component: Buttons,
//             meta: {
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'cards',
//             name: 'Cards',
//             component: Cards,
//             meta: {
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'grid-system',
//             name: 'Grid System',
//             component: GridSystem,
//             meta: {
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'icons',
//             name: 'Icons',
//             component: Icons,
//             meta: {
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'typography',
//             name: 'Typography',
//             component: Typography,
//             meta: {
//                 requireAuth: true
//             }
//         }
//     ]
// };
// let formsMenu = {
//     path: '/forms',
//     component: DashboardLayout,
//     redirect: '/forms/elements',
//     name: 'Forms',
//     children: [{
//             path: 'elements',
//             name: 'Form elements',
//             component: FormElements,
//             meta: {
//                 navbarType: 'light',
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'components',
//             name: 'Form components',
//             component: FormComponents,
//             meta: {
//                 requireAuth: true
//             }
//         },
//         {
//             path: 'validation',
//             name: 'Form validation',
//             component: FormValidation,
//             meta: {
//                 requireAuth: true
//             }
//         }
//     ]
// };

let salesMenu = {
    path: '/sales',
    component: DashboardLayout,
    redirect: '/sales/customers',
    name: 'SALES',
    children: [
        {
            path: 'customers',
            name: 'CUSTOMERS',
            component: Customers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'customer/:id',
            name: 'CUSTOMER',
            component: Customer,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'customized-prices',
            name: 'CUSTOMIZED_PRICES',
            component: CustomizedPrices,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'salechannels',
            name: 'SALE_CHANNELS',
            component: SaleChannels,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'salechannel/:id',
            name: 'SALE_CHANNEL',
            component: SaleChannel,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-documents',
            name: 'SALES',
            component: Sales,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-quotations',
            name: 'SALES_QUOTATIONS',
            component: Quotations,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-quotation/:id',
            name: 'SALES_QUOTATION',
            component: Quotation,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'sales-orders',
            name: 'SALES_ORDERS',
            component: Orders,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-order/:id',
            name: 'SALES_ORDER',
            component: Order,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-invoices',
            name: 'SALES_INVOICES',
            component: Invoices,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-invoice/:id',
            name: 'SALES_INVOICE',
            component: Invoice,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-invoice-from-do/:id',
            name: 'INVOICE_FROM_DO',
            component: invoiceFromDos,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'document-scanning',
            name: 'DOCUMENT_SCANNING',
            component: DocumentScanning,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-product-incident/:id',
            name: 'PRODUCT_INCIDENT_REPORT',
            component: SalesPIR,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'sales-product-incident',
            name: 'PRODUCT_INCIDENT_REPORTS',
            component: SalesPIRs,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'sales-item-pickings',
            name: 'SALES_ITEM_PICKINGS',
            component: SalesItemPickings,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'outstanding-invoices',
            name: 'OUTSTANDING_INVOICES',
            component: OutstandingInvoices,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'credit-limit-exceeded',
            name: 'CREDIT_LIMIT_EXCEEDED',
            component: CreditLimitExceeded,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'overdue-invoices',
            name: 'OVERDUE_INVOICES',
            component: OverdueInvoices,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'receipt-entries',
            name: 'RECEIPT_ENTRIES',
            component: ReceiptEntries,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-approval',
            name: 'SALES_APPROVAL',
            component: SalesApproval,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },       

    ]
};

let purchaseMenu = {
    path: '/purchase',
    component: DashboardLayout,
    redirect: '/purchase/vendors',
    name: 'PURCHASE',
    children: [
        {
            path: 'purchase-return/:id',
            name: 'PURCHASE_RETURN',
            component: PurchasePRT,
            meta: {
              navbarType: 'light',
              requireAuth: true
              }
        },
        {
            path: 'purchase-return',
            name: 'PURCHASE_RETURN',
            component: PurchasePRTs,
            meta: {
            navbarType: 'light',
            requireAuth: true
            }
        },        
        {
            path: 'vendors',
            name: 'VENDORS',
            component: Vendors,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'debit-notes',
            component: DebitNotes,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'debit-note/:id',
            component: DebitNote,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path: 'vendor/:id',
            name: 'VENDOR',
            component: Vendor,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'trade-items-purchase',
            name: 'TRADE_ITEMS_PURCHASE',
            component: TradeItemsPurchase,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-orders',
            name: 'PURCHASE_ORDERS',
            component: POS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-order/:id',
            name: 'PURCHASE_ORDER',
            component: PO,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'purchase-invoices',
            name: 'PURCHASE_INVOICES',
            component: PIS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-invoice/:id',
            name: 'PURCHASE_INVOICE',
            component: PI,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'purchase-invoice-from-grn/:id',
            name: 'INVOICE_FROM_GRN',
            component: invoiceFromGRN,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'document-scanning',
            name: 'DOCUMENT_SCANNING',
            component: DocumentScanning,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let productsMenu = {
    path: '/products',
    component: DashboardLayout,
    redirect: '/master',
    name: 'PRODUCTS',
    children: [{
            path: 'master',
            name: 'PRODUCT_MASTER',
            component: Products,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'detail/:id',
            name: 'PRODUCT',
            component: Product,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let rfidsMenu = {
    path: '/rfids',
    component: DashboardLayout,
    redirect: '/master',
    name: 'RFIDS',
    children: [{
            path: 'master',
            name: 'RFIDS_MASTER',
            component: RFIDS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'details/:id',
            name: 'RFID',
            component: RFID,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path:'upload-file',
            name:'UPLOAD',
            component:rfidUpload,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let usersMenu = {
    path: '/users',
    component: DashboardLayout,
    redirect: '/master',
    name: 'USERS',
    children: [
        {
            path: 'change-password',
            name: 'USER_CHANGE_PASSWORD',
            component: UserChangePassword,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'master',
            name: 'USER_MASTER',
            component: Users,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'detail/:id',
            name: 'USER',
            component: User,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let financeMenu = {
    path: '/finance',
    component: DashboardLayout,
    redirect: '/chart-of-accounts',
    name: 'FINANCE',
    children:[
        {
            path: 'period-locking',
            name: 'PERIOD_LOCKING',
            component: PeriodLocking,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'ar-credit-notes',
            name: 'AR_CREDIT_NOTES',
            component: ARcreditNotes,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'ar-credit-note/:id',
            name: 'AR_CREDIT_NOTE',
            component: ARcreditNote,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'ap-credit-notes',
            name: 'AP_CREDIT_NOTES',
            component: APcreditNotes,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'ap-credit-note/:id',
            name: 'AP_CREDIT_NOTE',
            component: APcreditNote,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path: 'ar-debit-notes',
            name: 'AR_DEBIT_NOTES',
            component: ARdebitNotes,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path: 'ar-debit-note/:id',
            name: 'AR_DEBIT_NOTE',
            component: ARdebitNote,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path: 'ap-debit-notes',
            name: 'AP_DEBIT_NOTES',
            component: APdebitNotes,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'jv-account-lookup',
            name: 'JV_ACCOUNT_LOOKUP',
            component: JVAccountLookup,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },       
        
        {
            path: 'ap-debit-note/:id',
            name: 'AP_DEBIT_NOTE',
            component: APdebitNote,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'customers-soa',
            name: 'CUSTOMERS_SOA',
            component: CustomersSOA,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-receipts',
            name: 'SALES_RECEIPTS',
            component: Receipts,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'sales-receipt/:id',
            name: 'SALES_RECEIPT',
            component: Receipt,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'purchase-receipts',
            name: 'PURCHASE_RECEIPTS',
            component: PurchaseReceipts,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'purchase-receipt/:id',
            name: 'PURCHASE_RECEIPT',
            component: PurchaseReceipt,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },        
        // {
        //     path: 'credit-notes',
        //     name: 'CREDIT_NOTES',
        //     component: creditNotes,
        //     meta: {
        //         navbarType: 'light',
        //         requireAuth: true
        //     }
        // },

        // {
        //     path: 'credit-note/:id',
        //     name: 'CREDIT_NOTE',
        //     component: creditNote,
        //     meta: {
        //         navbarType: 'light',
        //         requireAuth: true
        //     }
        // }
        ,
        {
            path: 'chart-of-accounts',
            name: 'CHART_OF_ACCOUNTS',
            component: COAS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'chart-of-accounts/:id',
            name: 'CHART_OF_ACCOUNT',
            component: COA,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'vouchers',
            name: 'VOUCHERS',
            component: Vouchers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'voucher/:id',
            name: 'VOCUHER',
            component: Voucher,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'gl-vouchers',
            name: 'GL_VOUCHERS',
            component: GLVouchers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'gl-voucher/:id',
            name: 'GL_VOUCHER',
            component: GLVoucher,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'bulk-posting',
            name: 'BULK_POSTING',
            component: BulkPosting,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'journal-vouchers',
            name: 'JOURNAL_VOUCHERS',
            component: JournalVouchers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path: 'journal-voucher/:id',
            name: 'JOURNAL_VOUCHER',
            component: JournalVoucher,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path: 'bank-reconciliation',
            name: 'BANK_RECONCILIATION',
            component: BankReconciliation,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

    ]
};

// let tablesMenu = {
//     path: '/tables',
//     component: DashboardLayout,
//     redirect: '/table/regular',
//     name: 'Tables menu',
//     children: [{
//             path: 'regular',
//             name: 'Tables',
//             component: RegularTables,
//             meta: { requireAuth: true }
//         },
//         {
//             path: 'sortable',
//             name: 'Sortable',
//             component: SortableTables,
//             meta: { requireAuth: true }
//         },
//         {
//             path: 'paginated',
//             name: 'Paginated Tables',
//             component: PaginatedTables,
//             meta: { requireAuth: true }
//         }
//     ]
// };

let authPages = {
    path: '/',
    component: AuthLayout,
    name: 'Authentication',
    children: [{
            path: '/home',
            name: 'DASHBOARD',
            component: Home,
            meta: {
                noBodyBackground: true,
                requireAuth: false
            }
        },
        {
            path: '/login',
            name: 'LOGIN',
            component: Login,
            meta: {
                requireAuth: false
            }
        },
        // {
        //     path: '/register',
        //     name: 'REGISTER',
        //     component: Register,
        //     meta: {
        //         requireAuth: false
        //     }
        // },
        // {
        //     path: '/pricing',
        //     name: 'Pricing',
        //     component: Pricing,
        //     meta: {
        //         requireAuth: false
        //     }
        // },
        // {
        //     path: '/lock',
        //     name: 'Lock',
        //     component: Lock,
        //     meta: {
        //         requireAuth: false
        //     }
        // },
        {
            path: '*',
            component: NotFound,
            meta: {
                requireAuth: false
            }
        }
    ]
};

let inventoryMenu = {
    path: '/inventory',
    component: DashboardLayout,
    redirect: '/locations',
    name: 'INVENTORY',
    children: [
        {
            path: 'locations',
            name: 'LOCATIONS',
            component: Locations,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'location/:id',
            name: 'LOCATION',
            component: Location,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stockadjustments',
            name: 'STOCKADJUSTMENTS',
            component: StockAdjustments,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            
            path: 'stockadjustment-details/:id',
            component: StockAdjustmentDetails,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stockadjustment/:id',
            component: StockAdjustment,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stock-in',
            name: 'STOCK_IN',
            component: stockin,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stock-out',
            name: 'STOCK_OUT',
            component: stockout,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stocktransfers',
            name: 'STOCK_TRANSFERS',
            component: stocktransfers,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stocktransfer/:id',
            name: 'STOCK_TRANSFER',
            component: stocktransfer,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'overview',
            name: 'OVERVIEW',
            component: productInventory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'grns',
            name: 'GOOD_RECEIVE_NOTES',
            component: GRNS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'grn/:id',
            name: 'GOOD_RECEIVE_NOTE',
            component: GRN,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'dos',
            name: 'DELIVERY_ORDERS',
            component: DOS,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'do/:id',
            name: 'DELIVERY_ORDER',
            component: DO,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'inventory-movements',
            name: 'INVENTORY_MOVEMENTS',
            component: InventoryMovements,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'stock-impairments',
            name: 'STOCKIMPAIRMENTS',
            component: StockImpairments,
            meta:{
              navbarType:'light',
              requireAuth: true
            }
        },
        {
            path: 'stock-impairment/:id',
            name: 'STOCKIMPAIRMENT',
            component: StockImpairment,
            meta:{
                navbarType:'light',
                requireAuth: true
            }
        },
        {
            path: 'bom-assemblies',
            name: 'BOMASSEMBLIES',
            component: BOMAssemblies,
            meta:{
              navbarType:'light',
              requireAuth: true
            }
        },
        {
            path: 'bom-assembly/:id',
            name: 'BOMASSEMBLY',
            component: BOMAssembly,
            meta:{
                navbarType:'light',
                requireAuth: true
            }
        },
    ]
};

let settingsMenu = {
    path: '/settings',
    component: DashboardLayout,
    redirect: '/contact-categories',
    name: 'SETTINGS',
    children: [
        {
            path: 'product-categories',
            name: 'PRODUCT_CATEGORIES',
            component: ProductCategories,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'product-categories/:id',
            name: 'PRODUCT_CATEGORY',
            component: ProductCategory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'contact-categories',
            name: 'CONTACT_CATEGORIES',
            component: ContactCategories,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'contact-categories/:id',
            name: 'CONTACT_CATEGORY',
            component: contactCategory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'system-settings',
            name: 'SYSTEM_SETTINGS',
            component: Systems,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'system-settings/:id',
            name: 'SYSTEM_SETTING',
            component: System,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'bank-account/:id',
            name: 'BANK_ACCOUNT',
            component: BankAccount,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'bank-accounts',
            name: 'BANK_ACCOUNTS',
            component: BankAccounts,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 
        {
            path: 'payroll',
            name: 'PAYROLL_SETUP',
            component: PayrollSetup,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }, 

    ]
};

let assetsMenu = {
    path: '/assets-management',
    component: DashboardLayout,
    redirect: '/assets',
    name: 'ASSETS_MANAGEMENT',
    children: [{
            path: 'assets',
            name: 'ASSETS',
            component: Assets,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'asset/:id',
            name: 'ASSET',
            component: Asset,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let assetClassificationsMenu = {
    path: '/assetclassifications-management',
    component: DashboardLayout,
    redirect: '/asset-classifications',
    name: 'ASSET_CLASSIFICATIONS_MANAGEMENT',
    children: [{
            path: 'asset-classifications',
            name: 'ASSET_CLASSIFICATIONS',
            component: AssetClassifications,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'details/:id',
            name: 'ASSET_CLASSIFICATION',
            component: AssetClassification,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]
};

let assetProtocolsMenu = {
    path: '/assetprotocols-management',
    component: DashboardLayout,
    redirect: '/asset-protocols',
    name: 'ASSET_PROTOCOLS_MANAGEMENT',
    children: [{
            path: 'asset-protocols',
            name: 'ASSET_PROTOCOLS',
            component: AssetProtocols,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'details/:id',
            name: 'ASSET_PROTOCOL',
            component: AssetProtocol,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        }
    ]

};

let reportsMenu = {
    path: '/reports',
    component: DashboardLayout,
    redirect: '/sales-price-history',
    name: 'REPORTS',
    children: [
        {
            path: 'sales-gp',
            name: 'SALES_GP',
            component: SalesGPReport,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'ageing-reports',
            name: 'AGEING_REPORTS',
            component: AgeingReports,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path:'purchase',
            component: PurchaseReports,
            meta:{
                type:'Purchase',
                reload: true,
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path:'inventory',
            component: InventoryReports,
            meta:{
                type:'Inventory',
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path:'sales',
            component: SalesReports,
            meta:{
                type:'Sales',
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path:'finance',
            component: FinanceReports,
            meta:{
                type:'Finance',
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path:'sales-debtor-report',
            name: 'SALES_DEBTORS',
            component: ReportDebtors,
            meta:{
                navbarType: 'light',
                requireAuth: true
            }
        },        
        {
            path: 'sales-price-history',
            name: 'SALES_PRICE_HISTORY',
            component: ReportSalesPriceHistory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path: 'inventory-stock-balance',
            name: 'STOCK_BALANCE_REPORT',
            component: ReportInventoryStockBalance,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path:'sales-soa',
            name: 'SALES_SOA',
            component: ReportSOA,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },
        {
            path:'sales-gst',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/gst/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'debtor-ageing-details',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/debtors-ageing-analysis-details/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'creditor-bills',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/creditor-bills-entry-lists/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-volume',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-volume/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'inventory-stock-movement',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/inventory_stockcard/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },

        

        {
            path:'product-sales-item-sales-report-by-department',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/product-sales-item-sales-report-by-department/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },


        {
            path:'purchase-transaction',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-transaction/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-volume-all-creditors',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-volume-all-creditors/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-volume-selected-items-volume-qty',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-volume-selected-items-volume-qty/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-reserved-goods-item-range',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-reserved-items-range/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-reserved-goods-category-range',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-reserved-category-range/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        {
            path:'purchase-reserved-customer-item-range',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/purchase-reserved-customer-item-range/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
  
                                                          
        
        {
            path: 'purchase-price-history-selected-creditor-and-item',
            name: 'PURCHASE_PRICE_HISTORY',
            component: ReportPurchasePriceHistory,
            meta: {
                navbarType: 'light',
                requireAuth: true
            }
        },

        {
            path:'category-listing',
            meta: {
               requiresAuth: true,
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/category-listing/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },

        {
            path:'stock-value-report-summary',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/stock-value-report-summary/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },

        {
            path:'item-balance-cost-by-category-range',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/item-balance-cost-by-category-range/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },
        
        {
            path:'item-balance-on-hands-by-category-range',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/item-balance-on-hands-by-category-range/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },

        {
            path:'sales-debtor-ageing',
            meta: {
               requiresAuth: true,
               //title: 'SALES_GST',
               breadcrumb: null
            },
             beforeEnter: () => {
               let url =  'https://reports.unityerp.com/esteam/debtors-ageing-analysis-summary/' +  localStorage.getItem('access_token');
               window.open(url);          
            }      
        },        
    ]
};

const routes = [
    {
        path: '/',
        redirect: '/dashboard',
        name: 'Home',
        meta: {
            requireAuth: true
        }
    },
    reportsMenu,
    // componentsMenu,
    // formsMenu,
    salesMenu,
    purchaseMenu,
    productsMenu,
    rfidsMenu,
    usersMenu,
    inventoryMenu,
    financeMenu,
    // tablesMenu,
    settingsMenu,
    assetsMenu,
    assetClassificationsMenu,
    assetProtocolsMenu,
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dashboard',
        name: 'DASHBOARD',
        children: 
        [
            {
                path: 'alternative',
                name: 'DASHBOARD',
                component: Dashboard,
                meta: {
                    requireAuth: true
                }
            },
            {
                path: 'dashboard',
                name: 'Alternative',
                component: AlternativeDashboard,
                meta: {
                    navbarType: 'light',
                    requireAuth: true
                }
            },
            {
                path: 'approval-requests',
                name: 'APPROVAL_REQUESTS',
                component: ApprovalRequests,
                meta: {
                    requireAuth: true,
                    navbarType: 'light',
                }
            }
        ]
    },
    authPages,
];

export default routes;